module.exports = __webpack_public_path__ + "img/membercz_active.2d3820ce.png";